import { HttpMethod } from '@nu-art/thunderstorm-shared';
export const ApiDef_Variable = {
    _v1: {
        getVariables: { method: HttpMethod.POST, path: '/v1/variables/get-variables' },
        getAttributes: { method: HttpMethod.POST, path: '/v1/variables/get-attributes' },
        createUIVariable: { method: HttpMethod.POST, path: '/v1/variables/create-ui-variable' },
        createAttributeInstance: { method: HttpMethod.POST, path: '/v1/variable/create-attribute-instance' },
        deleteVariable: { method: HttpMethod.POST, path: '/v1/variables/delete-variable' },
        createChild: { method: HttpMethod.POST, path: '/v1/variables/create-child' },
        convertToYesSusNo: { method: HttpMethod.POST, path: '/v1/variables/convert-to-yes-sus-no' },
    }
};
//# sourceMappingURL=api-def.js.map